import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FileWarning } from "lucide-react";

const LABELS = {
  business_name: "Business name", address: "Address", city: "City", state: "State",
  pin: "PIN code", phone: "Phone", gstin: "GSTIN",
};

// Globally mounted once (AppShell). Opens whenever any invoice-generating API call is
// blocked by the server-side invoice setup gate (INVOICE_SETUP_REQUIRED).
export function InvoiceSetupModal() {
  const [info, setInfo] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    const h = (e) => setInfo(e.detail);
    window.addEventListener("invoice-setup-required", h);
    return () => window.removeEventListener("invoice-setup-required", h);
  }, []);
  if (!info) return null;
  const missing = info.missing_fields || [];
  return (
    <Dialog open onOpenChange={() => setInfo(null)}>
      <DialogContent className="bg-white max-w-md" data-testid="invoice-setup-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display">
            <FileWarning className="h-5 w-5 text-amber-500" /> Invoice setup required
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 text-sm text-slate-600">
          <p>Before Pawkt can generate an invoice, you need to complete your business invoice details.</p>
          {missing.length > 0 && (
            <div className="rounded-lg bg-amber-50 border border-amber-200 p-3">
              <div className="text-xs font-semibold uppercase tracking-wide text-amber-700 mb-1">Missing</div>
              <ul className="list-disc pl-5 text-amber-800" data-testid="invoice-setup-missing">
                {missing.map((f) => <li key={f}>{LABELS[f] || f}</li>)}
              </ul>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setInfo(null)} data-testid="invoice-setup-cancel">Cancel</Button>
          <Button className="bg-slate-900 text-white" data-testid="invoice-setup-complete"
            onClick={() => { setInfo(null); nav(info.setup_url || "/invoice-settings"); }}>
            Complete Invoice Setup
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
